import _typeof from "@babel/runtime/helpers/typeof";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import PropTypes from 'prop-types';
import React from 'react';
import { jsx as _jsx } from "theme-ui/jsx-runtime";

var StackItem = function StackItem(props) {
  return _jsx("div", _objectSpread({
    sx: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }
  }, props));
};
/**
 * The **Stack** component is a layout component that makes it easy to stack elements together and apply a space between them.
 *
 */


export var Stack = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$as = _ref.as,
      As = _ref$as === void 0 ? 'div' : _ref$as,
      align = _ref.align,
      justify = _ref.justify,
      wrap = _ref.wrap,
      spacing = _ref.spacing,
      direction = _ref.direction,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["as", "align", "justify", "wrap", "spacing", "direction", "children"]);

  var dStyles = direction === 'row' ? {
    mr: spacing,
    '&:last-child': {
      mr: 0
    }
  } : {
    mb: spacing,
    '&:last-child': {
      mb: 0
    }
  };
  var styles = {
    display: 'flex',
    flexDirection: direction,
    alignItems: align,
    justifyContent: justify,
    flexWrap: wrap,
    variant: 'spark.base.wrapper',
    '& > *': dStyles
  };
  return _jsx(As, _objectSpread(_objectSpread({
    ref: ref,
    sx: styles
  }, props), {}, {
    children: React.Children.map(children, function (child, index) {
      if (typeof child === 'string' && child.length) return _jsx(StackItem, {
        children: child
      }, index);
      if (_typeof(child) === 'object' && child !== null && child.props.children || typeof child === 'number') return _jsx(StackItem, {
        children: child
      }, index);
      return child;
    })
  }));
});
Stack.propTypes = {
  // You can declare that a prop is a specific JS type. By default, these are all optional.
  align: PropTypes.oneOf(['flex-start', 'flex-end', 'stretch', 'center', 'baseline']),
  justify: PropTypes.oneOf(['flex-start', 'flex-end', 'center', 'stretch', 'space-between', 'space-around', 'space-evenly']),
  wrap: PropTypes.oneOf(['no-wrap', 'wrap', 'wrap-reverse']),
  spacing: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.arrayOf(PropTypes.string), PropTypes.arrayOf(PropTypes.number)]),
  direction: PropTypes.oneOf(['column', 'row'])
};
Stack.defaultProps = {
  align: 'center',
  justify: 'flex-start',
  wrap: 'no-wrap',
  spacing: '1em',
  direction: 'column'
};
Stack.displayName = 'Stack';